import React from 'react';
import Seventhgrade_k7 from './seventhgrade_k7';
import Seventhgrade_k7_subjects from './seventhgrade_k7_subjects';
const Seventhgrade_k7eng = () => {
  return (
    <div>
      <Seventhgrade_k7 />
    <Seventhgrade_k7_subjects />
    <div className='relative right-0 left-0 top-37 '>
      <h1>English section</h1>
      <h3>English section in the curriculum</h3>
      <li>Generic skills or Soft skills or 21st century skills integrated in agriculture learning and assessment </li>
      <li>Cross-cutting isues integrated in Agriculture learning and assessment </li>
      <li>Values integrated in Agriculture learning and assessment </li>
      </div>
    </div>
  );
}

export default Seventhgrade_k7eng;